import { reactive, ref } from 'vue';

import { LoginResult } from '../models/api';

const loginStatus = ref(false);

let loginDetail = reactive<LoginResult>({
  token: '',
  officeID: 0,
  officeName: '',
  superuser: '',
  registerStatus: false,
  registerAt: '',
  proxyID: 0,
});

const loginInitial = (initial: LoginResult) => {
  loginDetail = Object.assign(loginDetail, initial);
};

export default {
  loginStatus,
  loginInitial,
  loginDetail,
};
